import { render, staticRenderFns } from "./Form712.vue?vue&type=template&id=2b358c98&scoped=true&"
import script from "./Form712.vue?vue&type=script&lang=js&"
export * from "./Form712.vue?vue&type=script&lang=js&"
import style0 from "./Form712.vue?vue&type=style&index=0&id=2b358c98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b358c98",
  null
  
)

export default component.exports